import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { user_init_api } from "../../DAL/Users";

const LoginLayout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const result = await user_init_api();
      if (cancelled) return;
      if (result.code === 200) navigate("/home");
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="login_page">
      <div className="login-container">
        <Outlet />
      </div>
    </div>
  );
};

export default LoginLayout;
